var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions-menu-item",attrs:{"disabled":_vm.disabled},on:{"click":_vm.execute}},[_c('i',{class:_vm.iconClass}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }